/**
 * key -> productCode
 * value -> privateKey
 */
export default {
  PD202207050001: "7MPGO4S8I1FLX8SBHJ02WuSZn&5FFFA353E90111EB97D90242AC120002",
  PD202207060001: "xC6CgQ1g78LFvLXyEhbqZsseN&7A7A5A2FE90111EB8D240242AC120002",
  PD202207060002: "b9uWCKObjyFb4dGEGT2nSf5la&82A05789B17811EB8D240242AC120002",
  PD202207060003: "jeT4O7BVGk8sXvI24pQycIgPX&D3876616B17811EB9CFA0242AC120002",
  PD202207060004: "CEYJhwnImr1EuJfuVgRbUwuhC&A053AF30E90111EB80150242AC120002",
  PD202207060005: "hpY2dq4S6uq0nenf7Kd2RV5Z4&8F560350E90111EB8D240242AC120002",
  PD202207060006: "kkzwDnV7Kf8aKdvke3UDdIoqf&880DB228E90111EB9CFA0242AC120002",
  PD202207060007: "YzkpPNyGDMr8jHJEVQwt2TD9V&976B421FE90111EB80150242AC120002",
  PD202207060008: "FsXK3TT1OJtWa8oaLfsHK3DJE&A287F6D23DE411EC9CF00242AC120002",
  PD202207060009: "Z1aVnGwXrwToXZu1idZhygRgG&863C01483DE411EC901C0242AC120002",
  PD202207060010: "E4Oqly9XFpkDiAvBAkRZcp3GW&B3A5D4A33DE411EC9CF00242AC120002",
  PD202207060011: "2LDfUKwxtjH3v0o4tF433kqPo&E85C0A57B17811EB9CFA0242AC120002",
  PD202102230001: "nIOCrgs8SOjlR13WLyyECodc9&C0153455B48F11EB8D240242AC120002",
  PD202102230002: "Cm8uB7MdPT9x5vOKY401dz6mP&A3B170FAB48F11EB97D90242AC120002",
  PD202303230002: "54Bborcz8JRApwpcf0JUZAnra&7768F368C96511EDBDDF0242AC120002",
  PD202304060001: "54Bborcz8JRApwpcf0JUZAnra&7768F368C96511EDBDDF0242AC120002",
  PD202303230002: "LowAyu3rL0k5rVPHJtlpM37nK&4C157F05A97F11EB9F950242AC170002"  //测试环境
};
